import { BASIC_ADMIN } from '../../../../../shared/js/typeConstants';
import {
  faDatabase,
  faHandsHelping,
  faPiggyBank,
  faUsers,
  faComment,
  faMoneyCheck,
  faCog,
  faSignOutAlt,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";

export const DEFAULT_FIRST_LAYER_NAME = "first_layer";
export const SPLIT_KEY = ":-:";
/**
 * Menu Item Structure
 * { id,name, onClick, url, icon}
 */
export const DUMMY_MENU = [
  {
    groupName: "Manage",
    children: [
      {
        id: "dashboard",
        name: "Dashboard",
        icon: faDatabase,
      },
      {
        id: "teams",
        name: "Teams",
        icon: faUsers,
        children: [
          { name: "All Teams" },
          { name: "All Teams And biibi" },
          {
            name: "Add New Teams",
            children: [
              { name: "Male Teams" },
              { name: "Female  Teams" },
              { name: "LGBTQ Teams" },
            ],
          },
        ],
      },
      {
        id: "comments",
        name: "Messages",
        icon: faComment,
        link: "www.facebook.com",
      },
      {
        id: "assets&investments",
        name: "Assets & Investments",
        icon: faPiggyBank,
        children: [
          { name: "All Investments" },
          { name: "All Assets" },
          { name: "Add New Assets" },
        ],
      },
      {
        id: "payment",
        name: "Payment",
        icon: faMoneyCheck,
        children: [{ name: "All Payments" }, { name: "Pay User" }],
      },
      { name: "Trading", icon: faHandsHelping, id: "trading" },
    ],
  },
];

export const USER_DETAILS = {
  userName:
    localStorage.userDeta && JSON.parse(localStorage.userDeta)?.first_name
      ? JSON.parse(localStorage.userDeta)?.first_name
      : "NO DATA",
  role:
    localStorage.currentEnterprise && localStorage.currentEnterprise !== "null"
      ? JSON.parse(localStorage.currentEnterprise)?.name
      : "ROLE",
  companyName:
    localStorage.currentEnterprise && localStorage.currentEnterprise !== "null"
      ? JSON.parse(localStorage.currentEnterprise)?.name
      : "COMPANY",
  companyLogo: "https://via.placeholder.com/300",
};

const enterprise = localStorage.getItem("currentEnterprise")&& JSON.parse(localStorage.currentEnterprise)
const isBasicAdmin = enterprise?.role && enterprise?.role?.name === BASIC_ADMIN ? true : false;

export const BOTTOM_MENU = isBasicAdmin
  ? [
      {
        id: "signout",
        name: "Sign Out",
        icon: faSignOutAlt,
        onClick: () => {
          const iAmSureIWantToLogOut = window.confirm(
            "Are you sure you want to sign out?"
          );
          if (iAmSureIWantToLogOut) {
            localStorage.clear();
            window.location.href = "/";
          }
        },
      },
        ]
  : [
      {
        id: "users",
        name: "Users",
        icon: faUsers,
        link: "/enterprise/users",
      },
      {
        id: "wallets",
        name: "Wallets",
        icon: faWallet,
        link: "/enterprise/wallets",
      },

      {
        id: "settings",
        name: "Settings",
        icon: faCog,
        link: "/enterprise/manage",
      },
      {
        id: "signout",
        name: "Sign Out",
        icon: faSignOutAlt,
        onClick: () => {
          const iAmSureIWantToLogOut = window.confirm(
            "Are you sure you want to sign out?"
          );
          if (iAmSureIWantToLogOut) {
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/";
          }
        },
      },
    ];
